export const selectViewportAnchor = (
  elements,
  viewportHeight = typeof window === "undefined" ? 0 : window.innerHeight,
) => {
  const focusLine = Math.min(Math.max(viewportHeight * 0.2, 1), 160);
  const candidates = Array.from(elements || [])
    .map((element) => {
      const rect = element.getBoundingClientRect();
      const visibleHeight = Math.max(
        0,
        Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0),
      );
      return {
        element,
        rect,
        visibleHeight,
        containsFocusLine: rect.top <= focusLine && rect.bottom > focusLine,
        distanceFromFocusLine: Math.abs(rect.top - focusLine),
      };
    })
    .filter(({ visibleHeight }) => visibleHeight > 0)
    .sort(
      (left, right) =>
        Number(right.containsFocusLine) - Number(left.containsFocusLine) ||
        left.distanceFromFocusLine - right.distanceFromFocusLine ||
        right.visibleHeight - left.visibleHeight,
    );

  return candidates[0] || null;
};

export const calculateAnchoredScrollTop = ({
  currentScrollTop,
  currentAnchorTop,
  savedAnchorOffset,
}) => currentScrollTop + currentAnchorTop - savedAnchorOffset;
